import { type StylesConfig } from "react-select";

export const reactSelectColourStyles: StylesConfig<any> = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: "white",
    appearance: "none",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    height: "3rem",
    width: "100%",
    borderRadius: "16px",
    borderWidth: "2px",
    boxShadow: "none",
    borderColor: state.isFocused ? "#181818" : "tranparent",
    ":focus": {
      borderColor: "#181818",
    },
    ":active": {
      borderColor: "#181818",
    },
    ":hover": {
      borderColor: state.isFocused ? "#181818" : "tranparent",
    },
  }),
  input: (styles) => ({
    ...styles,
    padding: "1px",
  }),
  placeholder: (styles) => ({ ...styles }),
  singleValue: (styles) => ({ ...styles }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
};
